import { getSignedFileUrl } from '@/lib/utils';
import { Button } from '../ui/button';
import { useState } from 'react';

interface DownloadFileCellProps {
  fileUrl: string;
  linkLabel?: string;
}

const DownloadFileCell = ({ fileUrl, linkLabel = 'Descargar' }: DownloadFileCellProps) => {
  const [fileSignedUrl, setFileSignedUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateSignedFileUrl = async () => {
    setIsLoading(true);
    try {
      const url = await getSignedFileUrl(fileUrl);
      setFileSignedUrl(url);
      setIsLoading(false);
      window.open(url, '_blank');
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDownloadFile = () => {
    if (fileSignedUrl) {
      window.open(fileSignedUrl, '_blank');
    } else {
      handleCreateSignedFileUrl();
    }
  };

  return (
    <Button
      variant="link"
      className="px-0 text-foreground font-medium underline transition-colors hover:text-blue-500"
      isLoading={isLoading}
      onClick={handleDownloadFile}
    >
      {linkLabel}
    </Button>
  );
};

export { DownloadFileCell };
